/**
 * Converte path do storage ou URL completa em URL absoluta para exibição.
 * Dados vêm do banco (Supabase); se for path (ex: "uuid/123.jpg"), monta a URL do bucket public.
 */
export function getImageUrl(url: string | null | undefined): string {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    return `${supabaseUrl}/storage/v1/object/public/media/${url}`;
}
